import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { MapboxComponent } from './mapbox.component';

@NgModule({
  imports: [FormsModule, NgIf],
  declarations: [MapboxComponent],
  exports: [MapboxComponent],
})
export class MapboxModule {}
